module.exports = __webpack_public_path__ + "img/expand-more.9be22a9c.svg";